import { IChildProp } from "lib/interfaces/IChildProp";
import React, { FunctionComponent } from "react";
import FormText from "reactstrap/lib/FormText";
import Input from "reactstrap/lib/Input";
import Label from "reactstrap/lib/Label";
import { Error } from "../Error";

export interface ITextProps extends IChildProp {
  onChange?: (e?: any) => any;
  isValid?: boolean;
  infoMessage?: string;
  label?: string;
  name?: string;
  value?: any;
  placeholder?: string;
  errorMessage?: string;
  noMargin?: boolean;
}

export const Select: FunctionComponent<ITextProps> = (props: ITextProps) => {
  return (
    <Label className="w-100">
      {props.label ? props.label : null}
      <Input
        className={props.noMargin ? undefined : "mb-2 mt-1"}
        onChange={props.onChange}
        value={props.value || undefined}
        name={props.name || undefined}
        placeholder={props.placeholder || undefined}
        type="select"
        style={{ backgroundColor: '#ebecf1', borderRadius: '10px' }}
      >
        {props.children}
      </Input>
      {props.infoMessage ? (
        <FormText color="muted">{props.infoMessage}</FormText>
      ) : null}
      {props.isValid === false ? <Error>{props.errorMessage}</Error> : null}
    </Label>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/input/Select.tsx